$(document).ready(function () {
  function formatGbp(amount) {
    const num = typeof amount === 'string' ? Number(String(amount).replace(/[£$,]/g, '')) : Number(amount)
    return `£${num.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`
  }

  $.ajax({
    type: 'GET',
    url: '/products/remineralization-hot-cold-ro-dispenser-a2g.js',
    dataType: 'json',
    success: function (product) {
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(0)
        .find('.wd-compare-detail-item-product-price')
        .html(formatGbp(product.price / 100))
      $('.wd-compare-header .wd-compare-header-item')
        .eq(0)
        .find('.wd-compare-header-item-price')
        .html(formatGbp(product.price / 100))
    }
  })
  $.ajax({
    type: 'GET',
    url: '/products/reverse-osmosis-instant-hot-water-dispenser-system-m6hg.js',
    dataType: 'json',
    success: function (product) {
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(1)
        .find('.wd-compare-detail-item-product-price')
        .html(formatGbp(product.price / 100))
      $('.wd-compare-header .wd-compare-header-item')
        .eq(1)
        .find('.wd-compare-header-item-price')
        .html(formatGbp(product.price / 100))
    }
  })
  $.ajax({
    type: 'GET',
    url: '/products/waterdrop-remineralization-countertop-corero-system-c1sl.js',
    dataType: 'json',
    success: function (product) {
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(2)
        .find('.wd-compare-detail-item-product-price')
        .html(formatGbp(product.price / 100))
      $('.wd-compare-header .wd-compare-header-item')
        .eq(2)
        .find('.wd-compare-header-item-price')
        .html(formatGbp(product.price / 100))
    }
  })
  $(window).on('scroll', function () {
    var scrollTop = $(this).scrollTop()
    var offsetTop = $('.wd-compare-content').offset().top
    if (scrollTop > offsetTop) {
      $('.wd-compare-header').css('display', 'block')
    } else {
      $('.wd-compare-header').css('display', 'none')
    }
  })

  var wd_compare_index
  var pre_index
  var compareSwitching = false

  function lockCompareSelects() {
    compareSwitching = true
    $('.wd-compare').addClass('wd-compare-switching')
  }

  function unlockCompareSelects() {
    compareSwitching = false
    $('.wd-compare').removeClass('wd-compare-switching')
  }

  var window_width = $(window).width()
  if (window_width <= 1024) {
    $('.wd-compare-product .wd-compare-detail-item-product-choose-card-items')
      .eq(0)
      .find('.wd-compare-detail-item-product-choose-card-item[data-index="5"]')
      .removeClass('wd-compare-detail-item-product-choose-card-item-choosed')
    $('.wd-compare-product .wd-compare-detail-item-product-choose-card-items')
      .eq(1)
      .find('.wd-compare-detail-item-product-choose-card-item[data-index="5"]')
      .removeClass('wd-compare-detail-item-product-choose-card-item-choosed')
  }

  $('.wd-compare-detail-item-product-choose-select').click(function () {
    if (compareSwitching) {
      return false
    }
    wd_compare_index = $(this).parents('.wd-compare-detail-item').index()
    pre_index = $(this)
      .siblings('.wd-compare-detail-item-product-choose-card')
      .find(`.wd-compare-detail-item-product-choose-card-item-active`)
      .attr('data-index')

    if (window_width <= 767) {
      $('.wd-compare-detail-item-product-choose-card-popup').css('display', 'block')
      $('.wd-compare-detail-item-product-choose-select-mobile').css('display', 'flex')
      $('.wd-compare-detail-item-product-choose-card-popup-close').css('display', 'block')
      $('html').css('overflow', 'hidden')
      $('.wd-compare').css('z-index', '99')
      $(this).siblings('.wd-compare-detail-item-product-choose-select-mobile').css('border-bottom', '1px solid #2179CA')
      $(this)
        .parents('.wd-compare-detail-item')
        .siblings()
        .find('.wd-compare-detail-item-product-choose-select-mobile')
        .css('border-bottom', '1px solid #e2e2e2')
    }
    $(this).parents('.wd-compare-detail-items').find('.wd-compare-detail-item-product-choose-card').stop().slideUp()
    $(this).siblings('.wd-compare-detail-item-product-choose-card').stop().slideDown()
  })

  $('.wd-compare-detail-item-product-choose-select.wd-compare-detail-item-product-choose-select-mobile').click(
    function () {
      if (compareSwitching) {
        return false
      }
      $(this)
        .parents('.wd-compare-detail-item')
        .siblings()
        .find('.wd-compare-detail-item-product-choose-card')
        .css('display', 'none')
      $(this)
        .parents('.wd-compare-detail-item')
        .siblings()
        .find('.wd-compare-detail-item-product-choose-select-mobile')
        .css('border-bottom', '1px solid #e2e2e2')
      $(this).siblings('.wd-compare-detail-item-product-choose-card').css('display', 'block')
      $(this).css('border-bottom', '1px solid #2179CA')
    }
  )

  $('.wd-compare-detail-item-product-choose-card').mouseleave(function () {
    $(this).stop().slideUp()
  })
  $('.wd-compare-detail-item-product-choose-card-item').hover(
    function () {
      $(this).addClass('wd-compare-detail-item-product-choose-card-item-hover')
    },
    function () {
      $(this).removeClass('wd-compare-detail-item-product-choose-card-item-hover')
    }
  )
  $('.wd-compare-detail-item-product-choose-card-popup-close').click(function () {
    $(this).parents('.wd-compare-detail-items').find('.wd-compare-detail-item-product-choose-card').stop().slideUp()
    $('.wd-compare-detail-item-product-choose-card-popup').css('display', 'none')
    $('.wd-compare-detail-item-product-choose-select-mobile').css('display', 'none')
    $('.wd-compare-detail-item-product-choose-card-popup-close').css('display', 'none')
    $('html').css('overflow', 'auto')
    $('.wd-compare').css('z-index', 'auto')
  })

  $('.wd-compare-detail-item-product-choose-card-item').click(function () {
    if (compareSwitching || $(this).hasClass('wd-compare-detail-item-product-choose-card-item-choosed')) {
      return false
    }
    if (window_width <= 1024) {
      $(this).parents('.wd-compare-detail-items').find('.wd-compare-detail-item-product-choose-card').stop().slideUp()
      $('.wd-compare').css('z-index', 'auto')
    }
    if (window_width <= 767) {
      $(this).parents('.wd-compare-detail-items').find('.wd-compare-detail-item-product-choose-card').stop().slideUp()
      $('.wd-compare-detail-item-product-choose-card-popup').css('display', 'none')
      $('.wd-compare-detail-item-product-choose-select-mobile').css('display', 'none')
      $('.wd-compare-detail-item-product-choose-card-popup-close').css('display', 'none')
      $('html').css('overflow', 'auto')
    }

    var data_index = $(this).attr('data-index')
    if (data_index !== pre_index) {
      $('.wd-compare-detail-item-product-choose-card-items')
        .find(`[data-index="${pre_index}"]`)
        .removeClass('wd-compare-detail-item-product-choose-card-item-choosed')
      pre_index = data_index
    }
    $(this).siblings().removeClass('wd-compare-detail-item-product-choose-card-item-active')
    $(this).addClass('wd-compare-detail-item-product-choose-card-item-active')
    $(this).removeClass('wd-compare-detail-item-product-choose-card-item-choosed')
    $(this)
      .parents('.wd-compare-detail-item')
      .siblings()
      .find('.wd-compare-detail-item-product-choose-card-item')
      .each(function () {
        if ($(this).attr('data-index') === data_index) {
          $(this).addClass('wd-compare-detail-item-product-choose-card-item-choosed')
        }
      })

    var product_title = $(this).find('.wd-compare-detail-item-product-choose-card-item-title').html().trim()
    var product_value = $(this).data('value')
    var columnIndex = $(this).parents('.wd-compare-detail-item').index()
    wd_compare_index = columnIndex

    $(this)
      .parents('.wd-compare-detail-item-product-choose')
      .find('.wd-compare-detail-item-product-choose-select .wd-compare-detail-item-product-choose-name')
      .html(product_title)

    $(this)
      .parents('.wd-compare')
      .find('.wd-compare-header-item')
      .eq(columnIndex)
      .find('.wd-compare-header-item-title')
      .html(product_title)
    lockCompareSelects()
    $.ajax({
      type: 'GET',
      url: '/products/' + product_value + '.js',
      dataType: 'json',
      success: function (product) {
        $('.wd-compare-product .wd-compare-detail-item')
          .eq(columnIndex)
          .find('.wd-compare-detail-item-product-price')
          .html(formatGbp(product.price_max / 100))
        $('.wd-compare-header .wd-compare-header-item')
          .eq(columnIndex)
          .find('.wd-compare-header-item-price')
          .html(formatGbp(product.price_max / 100))
      },
      complete: function () {
        unlockCompareSelects()
      }
    })

    edit_info(product_title)
  })

  const compareIcon = {
    pure: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg',
    dimensions: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dimensions-svg.svg?v=1682313835',
    electricity: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-electricity-required-svg.svg?v=1682313835',
    warranty: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-warranty-svg.svg?v=1682315463',
    usage: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835',
    nsf: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817',
    nsfEmpty: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835',
    reduce: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg',
    dispensing: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg',
    dispensingNone: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835',
    filterLife: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg',
    smartNone: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg',
    temperature: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg',
    uv: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835',
    self: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg',
    volume: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027',
    sound: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg'
  }

  const newModelCompare = {
    A2G: {
      img: 'https://www.waterdropfilter.co.uk/cdn/shop/files/20260204-134420.png?v=1770196830',
      href: 'https://www.waterdropfilter.co.uk/products/remineralization-hot-cold-ro-dispenser-a2g',
      flow: '100 GPD',
      capacityTitle: '5-mode',
      capacitySub: 'Customizable Water Capacity',
      tankHtml:
        '<div class="wd-compare-detail-item-text">4.7L feed water tank</div>' +
        '<div class="wd-compare-detail-item-subtext">1.18L portable pitcher</div>',
      dimensions: '40.4 × 20.8 × 39.9 cm',
      weight: '10.0 kg',
      nsfText: '',
      nsfSrc: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835',
      stages: '6 Stages',
      reduce:
        'TDS, PFOA, PFOS, chlorine, salt, sediment, lead, odour and more; UV protection; mineral-enhanced water',
      annualCost: '£79.99',
      filters: [
        {
          name: 'A2RFG',
          life: '12 Mths',
          href: 'https://www.waterdropfilter.co.uk/products/waterdrop-a2rfg-ro-water-filter-for-wd-a2g-countertop-ro-system',
          img: 'https://www.waterdropfilter.co.uk/cdn/shop/files/US-WD-A2RFG-ERS-1110AR-US_____20251219_V1___1.png?v=1770100447'
        }
      ],
      dispensing: [true, true, true],
      smart: {
        filter_life: compareIcon.filterLife,
        tds: compareIcon.smartNone,
        temperature: compareIcon.temperature,
        uv: compareIcon.uv,
        self: compareIcon.self,
        adjustable: compareIcon.volume,
        sound: compareIcon.sound
      }
    },
    'K19-HG': {
      img: 'https://www.waterdropfilter.co.uk/cdn/shop/files/K19HG.png?v=1762920002',
      href: 'https://www.waterdropfilter.co.uk/products/waterdrop-k19-hg-instant-hot-water-reverse-osmosis-system',
      flow: '75 GPD',
      capacityTitle: '5-mode',
      capacitySub: '150ml / 250ml / 350ml / 500ml / 750ml',
      tankHtml: '<div class="wd-compare-detail-item-text">5L feed water tank</div>',
      dimensions: '35.0 × 20.0 × 41.5 cm',
      weight: '7.3 kg',
      nsfText: 'NSF/ANSI 58 & 372',
      nsfSrc: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817',
      stages: '7 Stages',
      reduce:
        'TDS, nitrate, fluoride, arsenic, lead, copper, chromium-VI, chlorine, chloramine, chloroform and more; UV; mineral addition',
      annualCost: '£89.00',
      filters: [
        {
          name: 'K19RFG',
          life: '12 Mths',
          href: 'https://www.waterdropfilter.co.uk/products/wd-k19rfg-filter-for-waterdrop-k19-hg-countertop-reverse-osmosis-system',
          img: 'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-K19RFG-___1.png?v=1766391395'
        }
      ],
      dispensing: [true, true, false],
      smart: {
        filter_life: compareIcon.filterLife,
        tds: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg',
        temperature: compareIcon.temperature,
        uv: compareIcon.uv,
        self: compareIcon.self,
        adjustable: compareIcon.volume,
        sound: compareIcon.sound
      }
    },
    M6SL: {
      img: 'https://www.waterdropfilter.co.uk/cdn/shop/files/2.WD-M6SL-_-_-__1.png?v=1785988574',
      href: 'https://www.waterdropfilter.co.uk/products/waterdrop-m6sl-mineral-reverse-osmosis-system-countertop-water-filter',
      flow: '75 GPD',
      capacityTitle: '5-mode',
      capacitySub: '150ml–500ml + Favourite Mode',
      tankHtml:
        '<div class="wd-compare-detail-item-text">5.5L dual tank: 4L tap + 1.5L waste</div>' +
        '<div class="wd-compare-detail-item-subtext">1.2L glass pitcher</div>',
      dimensions: '40.3 × 23.5 × 36.9 cm',
      weight: '9.58 kg',
      nsfText: 'NSF/ANSI 58 & 372',
      nsfSrc: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817',
      stages: '8 Stages',
      reduce:
        'Fluoride, PFOA, PFOS, TDS, chlorine, lead, heavy metals, VOCs, chromium, taste & odour and more; UV; mineral-infused water',
      annualCost: '£69.99',
      filters: [
        {
          name: 'M6RFL',
          life: '12 Mths',
          href: 'https://www.waterdropfilter.co.uk/products/m6rfl-replacement-filter-for-m6sl-countertop-ro-dispenser',
          img: 'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-M6SL-_M6RFL-_-__1.png?v=1785988177'
        }
      ],
      dispensing: [true, false, false],
      smart: {
        filter_life: compareIcon.filterLife,
        tds: compareIcon.nsfEmpty,
        temperature: compareIcon.smartNone,
        uv: compareIcon.uv,
        self: compareIcon.self,
        adjustable: compareIcon.volume,
        sound: compareIcon.sound
      }
    },
    M6HG: {
      img: 'https://www.waterdropfilter.co.uk/cdn/shop/files/1.WD-M6HG-_-_-__1.png?v=1784105075',
      href: 'https://www.waterdropfilter.co.uk/products/reverse-osmosis-instant-hot-water-dispenser-system-m6hg',
      flow: '75 GPD',
      capacityTitle: '150ml–MAX',
      capacitySub: 'Flexible volume + Favourite Mode',
      tankHtml:
        '<div class="wd-compare-detail-item-text">5.5L dual tank: 4L tap + 1.5L waste</div>' +
        '<div class="wd-compare-detail-item-subtext">1.2L glass pitcher</div>',
      dimensions: '40.39 × 23.62 × 36.83 cm',
      weight: '9.98 kg',
      nsfText: 'NSF/ANSI 58 & 372',
      nsfSrc: 'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817',
      stages: '8 Stages',
      reduce:
        'Fluoride, PFOA/PFOS, TDS, chlorine, lead, heavy metals, VOCs, chromium, taste & odour and more; UV; mineral-infused water',
      annualCost: '£69.99',
      filters: [
        {
          name: 'M6RFG',
          life: '12 Mths',
          href: 'https://www.waterdropfilter.co.uk/products/replacement-filter-m6rfg-for-m6cg',
          img: 'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-m6rfg-vis.png?v=1783321353'
        }
      ],
      dispensing: [true, true, false],
      smart: {
        filter_life: compareIcon.filterLife,
        tds: compareIcon.nsfEmpty,
        temperature: compareIcon.temperature,
        uv: compareIcon.uv,
        self: compareIcon.self,
        adjustable: compareIcon.volume,
        sound: compareIcon.sound
      }
    }
  }

  function imgHtml(src) {
    return `<img src="${src}" alt="" width="" height="">`
  }

  function filterLifeHtml(filters) {
    return filters
      .map(filter => {
        const img = filter.img
          ? `<div class="wd-compare-detail-item-img">${imgHtml(filter.img)}</div>`
          : '<div class="wd-compare-detail-item-img"></div>'
        return `<div class="wd-compare-detail-item-a">
    <a href="${filter.href}">
        ${img}
        <div class="wd-compare-detail-item-text">
        ${filter.name}
        </div>
        <div class="wd-compare-detail-item-text">
        ${filter.life}
        </div>
    </a>
  </div>`
      })
      .join('')
  }

  function applyNewModelCompare(title) {
    const spec = newModelCompare[title]
    if (!spec) {
      return
    }

    $('.wd-compare-header .wd-compare-header-item')
      .eq(wd_compare_index)
      .find('.wd-compare-header-item-img img')
      .attr('src', spec.img)
    $('.wd-compare-product .wd-compare-detail-item')
      .eq(wd_compare_index)
      .find('.wd-compare-detail-item-product-img img')
      .attr('src', spec.img)
    $('.wd-compare-product .wd-compare-detail-item')
      .eq(wd_compare_index)
      .find('.wd-compare-detail-item-product-shop a')
      .attr('href', spec.href)
    $('.wd-compare-detail-pure .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(`<div class="wd-compare-detail-item-svg">${imgHtml(compareIcon.pure)}</div>`)
    $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
      .eq(wd_compare_index)
      .find('.wd-compare-detail-item-text')
      .html(spec.flow)
    $('.wd-compare-detail-water_capacity_options .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(
        `<div class="wd-compare-detail-item-blacktext">${spec.capacityTitle}</div>` +
          `<div class="wd-compare-detail-item-subtext">${spec.capacitySub}</div>`
      )
    $('.wd-compare-detail-water .wd-compare-detail-item').eq(wd_compare_index).html(spec.tankHtml)
    spec.dispensing.forEach((enabled, index) => {
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(index)
        .html(imgHtml(enabled ? compareIcon.dispensing : compareIcon.dispensingNone))
    })
    $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
        ${imgHtml(
          'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg'
        )}
      </div>
      <div class="wd-compare-detail-item-subtext">No Installation</div>
      <div class="wd-compare-detail-item-svg">
        ${imgHtml(
          'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835'
        )}
      </div>
      <div class="wd-compare-detail-item-subtext">No drilling required</div>
    `)
    $('.wd-compare-detail-dimensions .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(
        `<div class="wd-compare-detail-item-svg">${imgHtml(compareIcon.dimensions)}</div>` +
          `<div class="wd-compare-detail-item-text">${spec.dimensions}</div>`
      )
    $('.wd-compare-detail-item_weight .wd-compare-detail-item')
      .eq(wd_compare_index)
      .find('.wd-compare-detail-item-text')
      .html(spec.weight)
    $('.wd-compare-detail-electricity .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(
        `<div class="wd-compare-detail-item-svg">${imgHtml(compareIcon.electricity)}</div>` +
          `<div class="wd-compare-detail-item-text">Yes</div>`
      )
    $('.wd-compare-detail-warranty .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(
        `<div class="wd-compare-detail-item-svg">${imgHtml(compareIcon.warranty)}</div>` +
          `<div class="wd-compare-detail-item-text">1 Year</div>`
      )
    $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(
        `<div class="wd-compare-detail-item-svg">${imgHtml(compareIcon.usage)}</div>` +
          `<div class="wd-compare-detail-item-text">Countertop</div>`
      )

    const nsfTextHtml = spec.nsfText
      ? `<div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>${spec.nsfText}</div>`
      : ''
    $('.wd-compare-detail-nsf .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(`<div class="wd-compare-detail-item-svg">${imgHtml(spec.nsfSrc)}${nsfTextHtml}</div>`)
    ;['fcc', 'ce', 'reddot_design', 'sgs', 'tuv', 'ul'].forEach(key => {
      $(`.wd-compare-detail-${key} .wd-compare-detail-item`)
        .eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">${imgHtml(compareIcon.nsfEmpty)}</div>`)
    })
    $('.wd-compare-detail-filtration .wd-compare-detail-item')
      .eq(wd_compare_index)
      .find('.wd-compare-detail-item-bigtext')
      .html(spec.stages)
    $('.wd-compare-detail-reduce .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(
        `<div class="wd-compare-detail-item-svg">${imgHtml(
          'https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg'
        )}</div>` +
          `<div class="wd-compare-detail-item-longtext">${spec.reduce}</div>`
      )
    $('.wd-compare-detail-average .wd-compare-detail-item')
      .eq(wd_compare_index)
      .find('.wd-compare-detail-item-text')
      .html(formatGbp(spec.annualCost))
    $('.wd-compare-detail-filter_life_span .wd-compare-detail-item')
      .eq(wd_compare_index)
      .html(filterLifeHtml(spec.filters))
    Object.keys(spec.smart).forEach(key => {
      $(`.wd-compare-detail-${key} .wd-compare-detail-item`)
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(imgHtml(spec.smart[key]))
    })
  }

  function edit_info(title) {
    if (title == 'A1') {

      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/1_c6c384c6-3e79-4f83-be0b-5318978db338.png?v=1764216300')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/1_c6c384c6-3e79-4f83-be0b-5318978db338.png?v=1764216300')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/ro-hot-cold-water-dispenser-a1')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('100 GPD')
      $('.wd-compare-detail-water_capacity_options .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-blacktext">5-mode </div>
        <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-water .wd-compare-detail-item')
        .eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-text">6.0L</div>`)
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
  No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No drilling required
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`46.5 × 19.8 × 43.4 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`17.5 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Countertop`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="" width="" height="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`6 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg" alt="" width="" height="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WD-A1-NSF-ANSI-372-certification.pdf?v=1688981708">View
        the report &gt;</a>
    </div>
  `)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/replacement-for-a1-countertop-ro-system-wd-a1-cf">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/ui-wd-a1-cf_cff6d9d6-ec0b-4944-9a5d-60ba111ca9dd.png?v=1690194307"
                alt="" width="" height="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-A1-CF
        </div>
        <div class="wd-compare-detail-item-text">
        CF-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/replacement-for-a1-countertop-ro-system-wd-a1-ro">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/ui-wd-a1-ro.png?v=1687763853"
                alt="" width="" height="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-A1-RO
        </div>
        <div class="wd-compare-detail-item-text">
        RO-12 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(129.97))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="" width="" height="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png" alt="" width="" height="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg" alt="" width="" height="">`
        )
    } else if (title == 'A2') {

      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/US-WD-A2-__ERS-1110AR-US___-__20250522_V1__1-min.png?v=1778142336')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/US-WD-A2-__ERS-1110AR-US___-__20250522_V1__1-min.png?v=1778142336')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr(
          'href',
          'https://www.waterdropfilter.co.uk/products/reverse-osmosis-hot-and-cold-water-dispenser-a2'
        )
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('100 GPD')
      $('.wd-compare-detail-water_capacity_options .wd-compare-detail-item')
        .eq(wd_compare_index)
        .html(
          `<div class="wd-compare-detail-item-blacktext">5-mode </div>
                    <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-water .wd-compare-detail-item')
        .eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-text">4.7L</div>`)
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
        No Installation   
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No drilling required
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`40.4 × 20.8 × 39.9 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`10.0 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Countertop`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="" width="" height="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`5 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg" alt="" width="" height="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment, large particles, scale
    </div>
    `)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/replacement-for-a2-countertop-ro-system-a2rf-ro">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/WD-A2RF-RO.png?v=1739519231"
                alt="" width="" height="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-A2RF-RO
        </div>
        <div class="wd-compare-detail-item-text">
            12 Mths 
        </div>
    </a>
  </div>
  `)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(69.99))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="" width="" height="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="" width="" height="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg" alt="" width="" height="">`
        )
    } else if (title == 'K19-H') {

      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/K19-H-icon.png?v=1737436624')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/K19-H-icon.png?v=1737436624')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/instant-hot-water-reverse-osmosis-system-wd-k19-h')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('75 GPD')
      $('.wd-compare-detail-water_capacity_options .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-blacktext">5-mode </div>
  <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-water .wd-compare-detail-item')
        .eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-text">5.0L</div>`)
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No drilling required
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`35.0 × 20.0 × 41.5 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`7.3 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Countertop`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="" width="" height="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 58 & 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`6 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg" alt="" width="" height="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>`)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/waterdrop-wd-k19rf-replacement-ro-filter-for-wd-k19-h-countertop-hot-water-dispensers">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/K19_5_0e0d1e17-c83f-45dd-bf68-0d71425da292.png?v=1779172621"
                alt="" width="" height="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-K19RF
        </div>
        <div class="wd-compare-detail-item-text">
        12 Mths
        </div>
    </a>
  </div>
  `)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(75))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="" width="" height="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png" alt="" width="" height="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg" alt="" width="" height="">`
        )
    } else if (title == 'C1H') {

      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/20251211-141216.png?v=1765448313'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/20251211-141216.png?v=1765448313'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/countertop-instant-hot-ro-system-corero-system-c1h')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('75 GPD')
      $('.wd-compare-detail-water_capacity_options .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-blacktext">5-mode </div>
        <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-water .wd-compare-detail-item')
        .eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-text">3.3L</div>`)
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No drilling required
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`29.7 × 21.1 × 34.8 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`6.4 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Countertop`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="" width="" height="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`6 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg" alt="" width="" height="">
    </div>
    <div class="wd-compare-detail-item-longtext">
    TDS,  PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment,  large particles, scale
    </div>`)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/waterdrop-c1rf-water-filter-for-wd-c1-countertop-ro-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/2_727711d6-3958-483e-a542-80d69442e508.png?v=1706161819"
                alt="" width="" height="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-C1RF
        </div>
        <div class="wd-compare-detail-item-text">
        12 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(49.99))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png" alt="" width="" height="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg" alt="" width="" height="">`
        )
    } else if (title == 'C1SL') {

      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/1_ebcae37d-bed5-4e67-a706-e55e0a1cbee0.png?v=1762927084')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/1_ebcae37d-bed5-4e67-a706-e55e0a1cbee0.png?v=1762927084')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr(
          'href',
          'https://www.waterdropfilter.co.uk/products/waterdrop-remineralization-countertop-corero-system-c1sl'
        )
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('75 GPD')
      $('.wd-compare-detail-water_capacity_options .wd-compare-detail-item')
        .eq(wd_compare_index)
        .html(
          `
                    <div class="wd-compare-detail-item-blacktext">5-mode </div>
                    <div class="wd-compare-detail-item-subtext">Customizable Water Capacity</div>`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-water .wd-compare-detail-item')
        .eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-text">3.3L</div>`)
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-none-svg.svg" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
    No Installation   
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-none-svg.svg?v=1682313835" alt="" width="" height="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      No drilling required
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`29.7 × 21.1 × 34.8 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`6.4 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg2.svg?v=1682313835" alt="" width="" height="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Countertop`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="" width="" height="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`7 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg" alt="" width="" height="">
    </div>
    <div class="wd-compare-detail-item-longtext">
    TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances <br><br>
Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>

Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended solids, rust, sediment, large particles, scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-C1.pdf?v=1705030291)">View
            the report &gt;</a>
    </div>
    `)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/countertop-corero-system-replacement-filter-c1rfg">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/ui-c1rfg-ph.png?v=1762314900"
                alt="" width="" height="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-C1RFG    
        </div>
        <div class="wd-compare-detail-item-text">
            12 Mths
        </div>
    </a>
  </div>
  `)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(69.00))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg" alt="" width="" height="">`
        )

      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png" alt="" width="" height="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg" alt="" width="" height="">`
        )
    } else if (newModelCompare[title]) {
      edit_info('A1')
      applyNewModelCompare(title)
    }
  }
})
